export const movements = {
      title: 'Movimientos',
      subtitle: 'Entradas, salidas, ajustes y transferencias',
      recordsTitle: 'Historial de movimientos',
      recordsDescription: 'Consulta y registra entradas, salidas, ajustes y transferencias.',
      new: '+ Nuevo movimiento',
      createTitle: 'Registrar movimiento',
      createSubtitle: 'Captura una entrada, salida, ajuste o transferencia de inventario.',
      emptyTitle: 'Sin movimientos disponibles',
      emptyDescription: 'No hay movimientos que coincidan con el filtro seleccionado.',
      allTypes: 'Todos',
      inbound: 'Entrada',
      outbound: 'Salida',
      adjustment: 'Ajuste',
      transfer: 'Transferencia',
      destinationWarehouse: 'Almacén destino',
      quantityMode: 'Tipo de captura',
      baseUnit: 'Unidad',
      preferredUnitSwitch: 'Unidad',
      preferredUnitSwitchHint: 'Convierte existencias y cantidades a la unidad predeterminada del producto.',
      unitCost: 'Costo unitario',
      unitCostReferenceHint: 'Costo por {{unit}}. Se precarga el último costo como referencia.',
      unitCostPackagingHint: 'Si capturas en {{packaging}}, el costo sigue siendo por {{unit}}.',
      stockSummaryTitle: 'Existencias actuales',
      totalStock: 'Existencias totales',
      warehouseStock: 'Existencias por almacén',
      warehouseStockWithName: 'Existencias en {{warehouse}}',
      operatedUnitCost: 'Costo unitario del movimiento',
      operatedUnitCostLastCost: 'Basado en el último costo registrado.',
      operatedUnitCostAverageCost: 'Basado en el costo promedio del almacén.',
      movementTotalCost: 'Costo total del movimiento',
      detailsTitle: 'Detalle del movimiento',
      movementTypeName: 'Tipo de movimiento',
      relatedWarehouse: 'Almacén relacionado',
      viewDetails: 'Ver información',
      balanceBefore: 'Existencia antes',
      balanceAfter: 'Existencia después',
      sourceWarehouseBalance: '{{warehouse}}: {{balance}}',
      destinationWarehouseBalance: '{{warehouse}}: {{balance}}',
      selectWarehouseForStock: 'Selecciona un almacén',
      destinationWarehouseMustDiffer: 'El almacén destino debe ser diferente al almacén origen.',
      notes: 'Notas',
      quantityInsufficientStock: 'El movimiento no puede dejar existencias negativas.',
      quantityMustBePositiveInbound: 'La cantidad de entrada debe ser positiva.',
      quantityMustBeNegativeOutbound: 'La cantidad de salida debe ser negativa.',
      quantityMustBeNegativeTransfer: 'La cantidad de transferencia debe ser negativa desde el almacén origen.',
      quantityInHint: 'Ingresa una cantidad positiva para aumentar existencias.',
      quantityOutHint: 'Ingresa una cantidad positiva; se registrará como salida.',
      quantityTransferHint: 'Ingresa una cantidad positiva; se descontará del almacén origen y se abonará al destino.',
      quantityAdjustmentHint: 'Usa un valor positivo para aumentar o negativo para disminuir existencias.',
      quantityPackagingHint: 'Cada {{packaging}} equivale a {{quantity}} {{unit}}.',
    } as const;
